import FillsGraphDataMessage from 'communication/types/fillsGraph/FillsGraphDataMessage';
import {
    createClearStreamDataAction,
    createWatchStreamAction,
    WidgetWatchStreamAction,
    WidgetClearStreamDataAction,
    createReceiveMessageAction,
    WidgetStreamMessageReceiveAction,
    WidgetStreamMessageReceivePayload,
    WidgetStreamActionPayload,
} from 'widgets/store/stream/actions';
import { WidgetType } from 'widgets/WidgetType';
import { WidgetTypeActionPayload } from 'widgets/store/actions';

export type FillsGraphMessageReceivePayload =
    WidgetStreamMessageReceivePayload<FillsGraphDataMessage>;

export type FillsGraphMessageReceive =
    WidgetStreamMessageReceiveAction<FillsGraphDataMessage>;

export const receiveMessageAction =
    createReceiveMessageAction<FillsGraphDataMessage>(WidgetType.FILLS_GRAPH);

export const clearFillGraphDataAction = createClearStreamDataAction(
    WidgetType.FILLS_GRAPH
);

export const fillsGraphWatchStream = createWatchStreamAction(
    WidgetType.FILLS_GRAPH
);
export type FillsGraphStreamActionPayload =
    | WidgetTypeActionPayload
    | WidgetStreamActionPayload
    | FillsGraphMessageReceivePayload;

export type FillsGraphStreamAction =
    | FillsGraphMessageReceive
    | WidgetClearStreamDataAction
    | WidgetWatchStreamAction;
